/**
 * Returns all focuable elements in a given parent element, or the document by default
 * @param element
 * @returns {*[]}
 */
const getFocusableElements = (element = document) => {
    return [...element.querySelectorAll(
        'a, button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])'
    )]
        .filter(el => !el.hasAttribute('disabled'))
}

export {
    getFocusableElements
}
